import { render, staticRenderFns } from "./navTabsFollow.vue?vue&type=template&id=1d4bb378&scoped=true&"
import script from "./navTabsFollow.vue?vue&type=script&lang=js&"
export * from "./navTabsFollow.vue?vue&type=script&lang=js&"
import style0 from "./navTabsFollow.vue?vue&type=style&index=0&id=1d4bb378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4bb378",
  null
  
)

export default component.exports